// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__pXytk","column":"IconButton_column__lXp-C"};